import axios from 'axios'
import jwt_decode from 'jwt-decode'

import HTTPErrorCodesToMessages from './HTTPErrorCodesToMessages'

const axiosInstance = axios.create({
  baseURL: process.env.API_URL,
  withCredentials: true,
})

axiosInstance.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('access_token')

  if (accessToken) {
    try {
      const decodedToken: any = jwt_decode(accessToken)
      const exp = decodedToken.exp

      if (!exp) {
        localStorage.removeItem('access_token')
        return config
      }

      const isExpired = Date.now() >= exp * 1000

      if (isExpired) {
        localStorage.removeItem('access_token')
      } else {
        config.headers = config.headers ?? {}
        config.headers.Authorization = `Bearer ${accessToken}`
      }
    } catch (error) {
      localStorage.removeItem('access_token')
    }
  }

  return config
})

axiosInstance.interceptors.response.use((response) => response, HTTPErrorCodesToMessages)

export default axiosInstance
